(() => {
  'use strict';

  const iframeRules = [
    {
      matches: (iframe) => iframe.id === 'merchantwidgetiframe' || iframe.src.includes('merchantverse'),
      title: 'Google Händlerbewertungen',
    },
    {
      matches: (iframe) => iframe.src.includes('youtube.com/embed') || iframe.src.includes('youtube-nocookie.com/embed'),
      title: 'YouTube-Video',
    },
    {
      matches: (iframe) => iframe.src.includes('player.vimeo.com/video'),
      title: 'Vimeo-Video',
    },
    {
      matches: (iframe) => iframe.src.includes('google.com/maps'),
      title: 'Standortkarte',
    },
  ];

  const labelIframe = (iframe) => {
    if (!(iframe instanceof HTMLIFrameElement) || iframe.title.trim()) return;

    const rule = iframeRules.find(({ matches }) => matches(iframe));
    if (rule) iframe.title = rule.title;
  };

  const scan = (root = document) => {
    if (root instanceof HTMLIFrameElement) labelIframe(root);
    root.querySelectorAll?.('iframe').forEach(labelIframe);
  };

  scan();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) scan(node);
      });
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
